<div class="reserver-un-bureau">
	<div class="header">
		<p-button
				icon="pi pi-angle-left"
				label="{{ determinerLabelRetour() }}"
				(click)="revenirEcranPrecedent()"/>

		<div class="container-site-zone">
			<app-selection-zone
					[mode]="Mode.Selection"
					(notifierZoneSelectionneeId)="onZoneSelectionnee($event)">
			</app-selection-zone>
		</div>

		<div class="texte-reservation">
			<span>{{ determinerTitreModaleEnFonctionDuree() }}</span>
			<span class="date-reservation">{{ recupererDateReservationBonFormat() }}</span>
			<span class="navigation-jour">
				<p-button (click)="deplacerJour(-1)" label="<"></p-button>
				<p-button
						label="{{ 'CALENDRIER_JOURS_TELETRAVAIL.AUJOURDHUI' | translate }}"
						icon="pi pi-calendar"
						class="button-aujourdhui"
						[disabled]="estDateDuJour()"
						(click)="allerDateDuJour()">
				</p-button>
				<p-button (click)="deplacerJour(1)" label=">"></p-button>
			</span>
		</div>
	</div>
	<div class="grid-container" #gridContainer>
		@if (loading()) {
			<div class="spinner">
				<div class="app-spinner"></div>
			</div>
		} @else {
			@if (!estIlotSelectionne()) {
				<app-grid-ilots
						[ilots]="ilots()"
						[duree]="duree()"
						[longueurParent]="longueurParent()"
						[hauteurParent]="hauteurParent()"
						[readonly]="!estModeReservation()"
						[estAffichagePlusieursIlots]="!estIlotSelectionne()"
						[labelHaut]="labelHaut()"
						[labelDroite]="labelDroite()"
						[labelBas]="labelBas()"
						[labelGauche]="labelGauche()"
						[estAffichageVertical]="estAffichageVertical()"
						[estAfficherLabelIlot]="true"
						[bureauPreferentielId]="bureauPreferentielUtilisateurCourant()"
						[utilisateurConnecte]="utilisateur"
						(onSelectionIlot)="selectionnerIlot($event)"/>
			} @else {
				<app-affichage-ilot-pour-reservation
						[readonly]="!estModeReservation()"
						[ilot]="ilotSelectionne()"
						[dateReservation]="dateReservation()"
						[duree]="duree()"
						[longueurParent]="longueurParent()"
						[hauteurParent]="hauteurParent()"
						[labelHaut]="labelHaut()"
						[labelDroite]="labelDroite()"
						[labelBas]="labelBas()"
						[labelGauche]="labelGauche()"
						[bureauPreferentielId]="bureauPreferentielUtilisateurCourant()"
						[utilisateurConnecte]="utilisateur"
						[estAffichageVertical]="estAffichageVertical()"/>
			}
		}
	</div>
</div>
